import * as types from '@/store/pagination/actionTypes';
import {
  CLEAR_INTEGRATIONS_PAGINATION_STATE,
  CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE,
  SET_ITEMS_PER_PAGE,
  CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE,
  CLEAR_SERVICES_ASSETS_PAGINATION_STATE,
  CLEAR_ITEMS_PER_PAGE,
  CLEAR_INFOSTEALERS_PAGINATION_STATE,
} from '@/store/pagination/mutationTypes';

export default {
  async [types.UPDATE_ITEMS_PER_PAGE]({ commit, getters }, { itemsPerPage, tab }) {
    try {
      const currentData = getters.paginationItemsPerPageByTabs;
      currentData[tab] = itemsPerPage;
      await commit(SET_ITEMS_PER_PAGE, currentData);
    } catch (e) {
      console.log(e);
    }
  },
  async [types.CLEAR_ITEMS_PER_PAGE]({ commit }) {
    await commit(CLEAR_ITEMS_PER_PAGE);
  },
  async [types.CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE]({ commit }) {
    commit(CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE);
  },
  async [types.CLEAR_INTEGRATIONS_PAGINATION_STATE]({ commit }) {
    commit(CLEAR_INTEGRATIONS_PAGINATION_STATE);
  },
  async [types.CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE]({ commit }) {
    commit(CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE);
  },
  async [types.CLEAR_SERVICES_ASSETS_PAGINATION_STATE]({ commit }) {
    commit(CLEAR_SERVICES_ASSETS_PAGINATION_STATE);
  },
  async [types.CLEAR_INFOSTEALERS_PAGINATION_STATE]({ commit }) {
    commit(CLEAR_INFOSTEALERS_PAGINATION_STATE);
  },
};
